import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { AngleDownSmall } from '@zooplus/icons';
import styles from './FormControl.module.scss.js';

const FormControl = ({ appendixItems, children, hasError = false, disabled = false, focused = false, className, select, innerClassname, notFullWidth, icon, ...otherProps }) => {
    return (jsxs("div", { className: classNames('z-form', className, notFullWidth && styles.notFullWidth), children: [jsxs("div", { className: styles.formElementWrapper, children: [jsx("div", { ...otherProps, className: classNames(styles.formElement, 'z-text-input', innerClassname, {
                            // z-input can be added back once SHOP-10836 is done.
                            'z-select': select,
                            [styles.focused]: focused,
                            'z-select--disabled': disabled && select,
                            'z-input--disabled': disabled && !select,
                            'z-select--error': hasError && select,
                            'z-text-input--error': hasError && !select,
                        }) }), appendixItems && (
                    // Show additional element at the end of this input field, such as the card icon
                    // for card input field, CVV icon for security input field,...
                    jsx("span", { className: styles.appendix, children: appendixItems })), select && (
                    // Add an arrow down icon if this field is a select field
                    jsx("i", { className: classNames('z-select__arrow', disabled && 'z-select__arrow--disabled', hasError && 'z-select__arrow--error'), children: jsx(AngleDownSmall, {}) })), !!icon && jsx("div", { className: styles.formElementIconContainer, children: icon })] }), children] }));
};

export { FormControl as default };
//# sourceMappingURL=FormControl.js.map
